import { Button, styled } from "@mui/material";

export const ButtonM = styled(Button)`
  height: 40px;
`;
